import { render, staticRenderFns } from "./skin-picker.vue?vue&type=template&id=3f5919e3&scoped=true&"
import script from "./skin-picker.ts?vue&type=script&lang=ts&"
export * from "./skin-picker.ts?vue&type=script&lang=ts&"
import style0 from "./skin-picker.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./skin-picker.vue?vue&type=style&index=1&id=3f5919e3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5919e3",
  null
  
)

export default component.exports